import { useEffect, useState } from "react"

export enum EnumInvoiceStatus {
    PAID = "paid",
    DRAFT = "draft",
    OPEN = "open",
    UNCOLLECTIBLE = "uncollectible",
    VOID = "void"
}

export default function useInvoiceStatus(invoiceStatus: string) {
    const [statusInvoiceName, setStatusInvoiceName] = useState<string>("paid");
    
    useEffect(() => {
        switch(invoiceStatus) {
            case EnumInvoiceStatus.PAID:
                setStatusInvoiceName("Pago");
                break;
            case EnumInvoiceStatus.DRAFT:
                setStatusInvoiceName("Iniciado");
                break;
            case EnumInvoiceStatus.OPEN:
                setStatusInvoiceName("Aberto");
                break;
            case EnumInvoiceStatus.UNCOLLECTIBLE:
                setStatusInvoiceName("Não coletado");
                break;
            case EnumInvoiceStatus.VOID:
                setStatusInvoiceName("Vazio");
                break;
        }
    }, []);

    return { statusInvoiceName }
}